import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!

  return (_openBlock(), _createBlock(_component_DxNumberBox, {
    value: _ctx.value,
    "show-spin-buttons": _ctx.showSpinButtons,
    "show-clear-button": _ctx.hasEmptyValue,
    hint: _ctx.hint,
    min: _ctx.min,
    max: _ctx.max,
    disabled: _ctx.disabled,
    readOnly: _ctx.readOnly,
    placeholder: _ctx.placeholder,
    step: _ctx.step,
    isValid: _ctx.isValid,
    format: _ctx.format,
    visible: _ctx.visible,
    onValueChanged: _ctx.valueChanged,
    onKeyDown: _ctx.keyDown,
    onOnContentReady: _ctx.contentReady,
    onOnEnterKey: _ctx.enterKey,
    onInitialized: _ctx.initialized
  }, null, 8, ["value", "show-spin-buttons", "show-clear-button", "hint", "min", "max", "disabled", "readOnly", "placeholder", "step", "isValid", "format", "visible", "onValueChanged", "onKeyDown", "onOnContentReady", "onOnEnterKey", "onInitialized"]))
}